import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaypalCancel() {
  return (
    <div className="min-h-screen bg-midnight text-white flex items-center justify-center px-5" data-testid="paypal-cancel-page">
      <div className="max-w-md w-full text-center py-12">
        <XCircle size={64} className="text-white/40 mx-auto mb-6" />
        <h1 className="font-display text-3xl mb-3">Pagamento annullato</h1>
        <p className="text-white/70 text-sm leading-relaxed mb-8">
          Hai annullato il pagamento della caparra. Nessun addebito è stato effettuato.
          Puoi tornare alla home e riprovare quando vuoi.
        </p>
        <Link
          to="/"
          className="btn-gold inline-block px-8 py-3 text-xs uppercase tracking-widest font-semibold"
          data-testid="paypal-cancel-home"
        >
          Torna alla Home
        </Link>
      </div>
    </div>
  );
}
